import { EntityListSkuInputData } from '../entityListTypes';
import { BaseEntityListItemValidator } from './BaseEntityListItemValidator';
import { EntityListProductItemValidator } from './EntityListProductItemValidator';
import { ImportedItemValidatorContext } from '../../../../../lib/imports/importTypes';

/**
 * Checks if the pasted data contains both the store and product.
 * Uses EntityListProductItemValidator to check the product.
 */
export class EntityListSkuItemValidator extends BaseEntityListItemValidator<EntityListSkuInputData> {
  private productValidator = new EntityListProductItemValidator();

  validate(
    item: Partial<EntityListSkuInputData>,
    context?: ImportedItemValidatorContext[],
  ): string[] {
    const productErrors: string[] = this.productValidator.validate(item, context);
    const storeErrors: string[] = this.checkStore(item, context);

    return productErrors.concat(storeErrors);
  }

  protected checkStore = (
    item: Partial<EntityListSkuInputData>,
    context?: ImportedItemValidatorContext[],
  ): string[] => {
    const errors: string[] = [];

    if (!this.hasNonEmptyProperty(item, 'store')) {
      errors.push('Store cannot be empty');
    } else {
      const storeContext = context?.find(c => c.id === 'store');
      if (storeContext) {
        const pattern = storeContext.pattern;
        const store = item.store;
        if (store) {
          if (!pattern.test(store)) {
            errors.push(storeContext.errorMessage);
          }
        }
      }
    }

    return errors;
  };
}
